<template>
  <span>
    <v-select
      v-if="editing"
      :disabled="disabled"
      :items="items"
      :value="text"
      @change="changed"
      :rules="required_rule"
      :label="label"
      ref="atinput"
      @blur="blur"
    ></v-select>
    <span v-else>
      <span v-if="hasTooltip">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ rotext }}</span>
          </template>
          {{ tooltip }}
        </v-tooltip>
      </span>
      <span v-else>{{ rotext }}</span>
    </span>
  </span>
</template>

<script>
import { trim } from "lodash";
import ATInputMixin from "./ATInputMixin.js";

export default {
  mixins: [ATInputMixin],
  computed: {
    required_rule() {
      return this.required ? [value => !!trim(value) || "Required."] : [];
    },
    rotext() {
      this.$log.debug("rotext:", this.items, this.text);
      if (!this.items) return "";
      let fitem = this.items.find(i => i.value == this.text);
      return (fitem || {}).text;
    }
  }
};
</script>
